import { helpers } from '@vuelidate/validators';
import { password } from '@/common/utils/Util';

export const login = {
  id: {
    isEmpty: helpers.withMessage('아이디를 입력하세요.', (val) => !!val)
  },
  password: {
    isEmpty: helpers.withMessage('비밀번호를 입력하세요.', (val) => !!val)
  }
};

export const changePassword = {
  oldPassword: {
    isEmpty: helpers.withMessage('비밀번호를 입력해 주세요.', (val) => !!val),
    isValid: helpers.withMessage('영문, 숫자 포함 6자리 이상 입력해 주세요.', (val) => password.test(val))
  },
  newPassword: {
    isEmpty: helpers.withMessage('변경할 비밀번호를 입력해 주세요.', (val) => !!val),
    isValid: helpers.withMessage('영문, 숫자 포함 6자리 이상 입력해 주세요.', (val) => password.test(val))
  },
  confirm: {
    isEmpty: helpers.withMessage('필수입력사항입니다.', (val) => !!val),
    isNotSame: helpers.withMessage(
      '변경할 비밀번호가 일치하지 않습니다.',
      (value, { newPassword }) => value === newPassword
    )
    // isValid: helpers.withMessage('영문, 숫자, 특수문자 포함 6자리 이상 입력해 주세요.', (val) => regExp.test(val))
  }
};
